import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { NotificationManagerService } from './core/services/notification-manager.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-test-email',
  standalone: true,
  imports: [],
  template: `
    <div
      class="test-email-container"
      style="padding: 20px; max-width: 800px; margin: 0 auto;"
    >
      <h2>Email Template Test</h2>

      <div style="margin-bottom: 20px;">
        <button
          (click)="testEmailTemplate()"
          style="padding: 10px 20px; background: #00bcd4; color: white; border: none; border-radius: 5px; cursor: pointer;"
        >
          Generate Sample Email
        </button>

        <button
          (click)="clearPreview()"
          style="padding: 10px 20px; background: #f44336; color: white; border: none; border-radius: 5px; cursor: pointer; margin-left: 10px;"
        >
          Clear Preview
        </button>
      </div>

      @if (emailHtml) {
        <div
          style="border: 2px solid #ddd; padding: 20px; border-radius: 8px; background: #f9f9f9;"
        >
          <h3>Email Preview:</h3>
          <div
            [innerHTML]="emailHtml"
            style="background: white; padding: 20px; border-radius: 5px;"
          ></div>
        </div>
      }

      @if (emailSubject) {
        <div
          style="margin-top: 20px; padding: 10px; background: #e8f5e8; border-radius: 5px;"
        >
          <strong>Subject:</strong> {{ emailSubject }}
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .test-email-container {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      }
      button:hover {
        opacity: 0.9;
      }
    `,
  ],
})
export class TestEmailComponent {
  private notificationService = inject(NotificationManagerService);
  private sanitizer = inject(DomSanitizer);

  emailHtml: SafeHtml | null = null;
  emailSubject: string | null = null;

  testEmailTemplate(): void {
    // First test the service method
    this.notificationService.testEmailTemplateRendering();

    // Now get the actual template for display
    const sampleData = {
      vulnerabilityName: 'SQL Injection Vulnerability',
      cveId: 'CVE-2025-DEMO-002',
      cvssScore: 8.1,
      vulnerabilityDescription:
        'High severity SQL injection vulnerability allows remote code execution through database queries.',
      affectedAssetsCount: 3,
      riskLevel: 'Critical',
      exploitability: 'High',
      affectedAssets: [
        {
          name: 'demo-server-01',
          ipAddress: '10.0.1.100',
          service: 'MySQL',
          status: 'Vulnerable',
        },
        {
          name: 'demo-server-02',
          ipAddress: '10.0.1.101',
          service: 'PostgreSQL',
          status: 'Vulnerable',
        },
      ],
      vulnDetailsUrl: '/vulnerabilities/CVE-2025-DEMO-002',
      remediationUrl: '/remediation/CVE-2025-DEMO-002',
      vulnerabilityUrl: '/vulnerabilities',
      logoUrl:
        'https://cdn.prod.website-files.com/67368f6c79297610e225f43b/67378b875c07c4139458e3ba_logo-top.png',
      dashboardUrl: '/dashboard',
      settingsUrl: '/settings',
      supportUrl: '/support',
      unsubscribeUrl: '/unsubscribe',
    };

    try {
      // Get the email template service directly
      const templateService = (this.notificationService as any)
        .emailTemplateService;
      const template =
        templateService.getCriticalVulnerabilityTemplate(sampleData);

      // Sanitize and display the HTML
      this.emailHtml = this.sanitizer.bypassSecurityTrustHtml(
        template.htmlContent,
      );
      this.emailSubject = template.subject;

      // Email template rendered successfully
    } catch (error) {
      console.error('❌ Error rendering email template in component:', error);
    }
  }

  clearPreview(): void {
    this.emailHtml = null;
    this.emailSubject = null;
  }
}
